
import { i18nText } from '@/locales';
import { ServicesCategoryStore } from "@/store/modules/ServicesCategory";
import { ServiceStore } from "@/store/modules/Services";
import { IServicesCategory, IServicesCategoryListItem } from "@/entity/servicesCategory/services.category.types";
import Component from "vue-class-component";
import { mixins } from "vue-class-component";
import { ServicesMix } from "./ServicesMix";
import { IServicesListItem } from "@/entity/services/services.types";
import { ServiceCategoryForm } from "@/form/serviceCategory/serviceCategory";
import { showNotificationSimple } from "@/UI/lib/messages";
import { checkUserRole } from "@/router/Lib/helper";

@Component
export class ServiceCategoryMix extends mixins(ServicesMix) {
    dtreeServicesData: any[] = [];
    sourceDtreeServicesData: any[] = [];
    servicesData: any[] = [];
    get servicesCategory(): IServicesCategory | null {
        return ServicesCategoryStore.serviceCategory;
    }
    get serviceCategory(): IServicesCategoryListItem | null {
        return ServicesCategoryStore.servicesCategory;
    }
    findCategoryData(id: number): any {
        let data = null;
        this.servicesData.forEach((sd: IServicesListItem) => {
            if (Number(sd["id"] === id)) {
                data = sd;
            }
        });
        return data;
    }

    async findCategoryinStore(id: number, is_parent: boolean, salon_id: number, service?: any): Promise<void> {
        console.log("<<<<<<<<<<<<<<<<<<findCategoryinStore>>>>>>>>>>>>>>>>")
        await ServicesCategoryStore.fetchData({ filter: { id: id } });
        const categoryName = ServicesCategoryStore.servicesCategory;
        if (categoryName) {
            let filter = {};

            if (checkUserRole() === "owner") {
                filter = { salon_id: 0, name: categoryName["name"] };
            } else {
                filter = { is_parent: false, salon_id: salon_id, name: categoryName["name"] };
            }


            await ServicesCategoryStore.fetchData({
                filter: filter,
            });

            let newCategoryName = ServicesCategoryStore.servicesCategory;
            if (newCategoryName === undefined) {
                const service = new ServiceCategoryForm();
                service["name"] = categoryName["name"];
                service["salon_id"] = salon_id;
                ServicesCategoryStore.create(service).then(async (response) => {
                    showNotificationSimple(i18nText("Создание категории услуги -") + categoryName["name"], response.response, 10);
                    console.log("Copy Service Copied " + response);
                    await ServicesCategoryStore.fetchData({
                        filter: {
                            is_parent: false,
                            salon_id: salon_id,
                            name: categoryName["name"],
                        },
                    });
                    newCategoryName = ServicesCategoryStore.servicesCategory;
                });
            }
            /*if (ServicesCategoryStore.servicesCategory) {
                const existCaterogy = ServicesCategoryStore.servicesCategory;

                if (service) {
                    await ServiceStore.fetchData({ filter: { id: Number(service) } });
                    if (ServiceStore.services) {
                        const serviceData = ServiceStore.services;

                        const copyServiceData = new ServiceFormData();
                        copyServiceData["active"] = true;
                        copyServiceData["name"] = serviceData["name"];
                        copyServiceData["description"] = serviceData["description"];
                        copyServiceData["online_appointment_name"] = serviceData["online_appointment_name"];
                        copyServiceData["category_id"] = Number(existCaterogy["id"]);
                        copyServiceData["salon_id"] = Number(salon_id);
                        copyServiceData["image"] = 0;
                        copyServiceData["price_first"] = serviceData["price_first"];
                        copyServiceData["price_second"] = serviceData["price_second"];
                        copyServiceData["service_duration"] = serviceData["service_duration"];

                        ServiceStore.createFromCopy(copyServiceData).then(async (response) => {
                            showNotificationSimple(
                                "Копирование услуги - " + serviceData["name"],
                                response.response,
                                10,
                            );
                            //console.log(" Service Created " + response);
                        });
                    }
                }
            }*/
            console.log("Service Catetory -" + categoryName);
        }
    }

    searchInServicesData(source: string): any[] {
        const sData: any[] = [];
        this.dtreeServicesData.forEach((value: any, index: any) => {
            if (value && value["children"]) {
                const childrenData: any[] = [];
                value["children"].forEach((children: any) => {
                    if (children && children["title"]) {
                        if (children["title"].toLowerCase().search(source.toLowerCase()) !== -1) {
                            childrenData.push(children);
                        }
                    }
                });
                if (childrenData.length > 0) {
                    sData.push({
                        key: value["key"],
                        title: value["title"],
                        children: childrenData,
                    });
                }
            }
        });
        return sData;
    }
    async ParseCategory(dataCategory: IServicesCategory): Promise<void> {
        let childrenData: any[] = [];
        for (const category of dataCategory["data"]) {
            let filter = {};
            if (checkUserRole() === "owner") {
                filter = {
                    category_id: category["id"],
                    salon_id: 0,
                };
            } else {
                filter = {
                    category_id: category["id"],
                };
            }
            await ServiceStore.fetchAll({ filter: filter }).then(() => {
                if (this.service !== null && this.service.data !== undefined) {
                    if (this.service.data) {
                        this.service.data.forEach((service: IServicesListItem) => {
                            this.servicesData.push(service);
                            childrenData.push({
                                title: service["name"],
                                key: category["id"] + "-" + service["id"],
                            });
                        });
                    }
                    this.dtreeServicesData.push({
                        title: category["name"],
                        key: String(category["id"]),
                        children: childrenData,
                    });
                    childrenData = [];
                } else {
                    this.dtreeServicesData.push({ title: category["name"], key: category["id"], children: [] });
                }
            });
        }
    }


    async ServicesWithCategoriesNew(): Promise<void> {
        if (ServicesCategoryStore.serviceCategory) {
            let childrenData: any[] = [];

            ServicesCategoryStore.serviceCategory.data.forEach((category: IServicesCategoryListItem) => {
                ServiceStore.fetchAll({ filter: { category_id: category["id"] } }).then(() => {
                    if (this.service !== null && this.service.data !== undefined) {
                        if (this.service.data) {
                            this.service.data.forEach((service: IServicesListItem) => {
                                this.servicesData.push(service);
                                childrenData.push({
                                    title: service["name"],
                                    key: category["id"] + "-" + service["id"],
                                });
                            });
                        }
                        this.dtreeServicesData.push({
                            title: category["name"],
                            key: String(category["id"]),
                            children: childrenData,
                        });
                        childrenData = [];
                    } else {
                        this.dtreeServicesData.push({ title: category["name"], key: category["id"], children: [] });
                    }
                });
            });
            this.sourceDtreeServicesData = this.dtreeServicesData;
        }
    }

    async ServicesWithCategories(): Promise<void> {
        if (checkUserRole() === "owner") {
            //TODO:: решить вопрос с магией
            await ServicesCategoryStore.fetchAll({}, true);
            //await ServicesCategoryStore.fetchAll({ filter: { is_parent: true, salon_id:0 } });
        } else {
            await ServicesCategoryStore.fetchAll();
        }

        if (ServicesCategoryStore.serviceCategory) {
            await this.ParseCategory(ServicesCategoryStore.serviceCategory);
            let childrenData: any[] = [];

            ServicesCategoryStore.serviceCategory.data.forEach((category: IServicesCategoryListItem) => {
                ServiceStore.fetchAll({ filter: { category_id: category["id"] } }).then(() => {
                    if (this.service !== null && this.service.data !== undefined) {
                        if (this.service.data) {
                            this.service.data.forEach((service: IServicesListItem) => {
                                //Закомментировал пуш, т.к. в Лояльность/Типы сертификатов/Создание типа абонемента в селекте дублируются позиции

                                /* this.servicesData.push(service); */
                                childrenData.push({
                                    title: service["name"],
                                    key: category["id"] + "-" + service["id"],
                                });
                            });
                        }
                        //Закомментировал пуш, т.к. в Лояльность/Типы сертификатов/Создание типа абонемента в селекте дублируются позиции

                        /* this.dtreeServicesData.push({
                            title: category["name"],
                            key: String(category["id"]),
                            children: childrenData,
                        });
                        console.log("ServicesWithCategories 2", this.dtreeServicesData) */
                        childrenData = [];
                    } else {
                        this.dtreeServicesData.push({ title: category["name"], key: category["id"], children: [] });
                    }
                });
            });

            this.sourceDtreeServicesData = this.dtreeServicesData;
        }
    }
}
